import { createSlice } from '@reduxjs/toolkit';

// Slice
const slice = createSlice({
  name: 'employee',
  initialState: {
    employee: null,
  },
  reducers: {
    setEmployee: (state, { payload }) => {
      state.employee = payload;
    },
  },
});

// Actions
export const { setEmployee } = slice.actions;

export default slice.reducer;
